import { useReducer } from "react";
import carBrandReducer from "./carBrandReducer";
import carBrandContext from "./carBrandContext";

export default function CarBrandState({ children }) {

    const initialState = {
        brand: null
    };

    const [state, dispatch] = useReducer(carBrandReducer, initialState);

    const setBrand = (brand) => {
        dispatch({ type: "SET_CAR_BRAND", payload: brand });
    }

    const clearBrand = () => {
        dispatch({ type: "CLEAR_CAR_BRAND" });
    }

    return (
        <carBrandContext.Provider value={{ state, dispatch, setBrand, clearBrand }}>
            {children}
        </carBrandContext.Provider>
    )
}